import { Component } from '@angular/core';
import {
  Router,
  RouterLinkActive,
  ResolveStart,
  ActivatedRoute,
  NavigationEnd,
} from '@angular/router';
import { AuthenticationService } from './services/authentication.service';
import { MessagingService } from './messaging.service';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  url;
  user;
  show;
  isShowSidebar: Boolean = false;
  isEditProfile: Boolean = null;
  subscription: Subscription

  constructor(
    private router: Router,
    public authenticationService: AuthenticationService,
    private route: ActivatedRoute
  ) {
    this.authenticationService.getIsProfileUpdate().subscribe((item: any) => {
      this.isEditProfile = item;
    })
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        if (event.url == '/') {
          return (this.isShowSidebar = false);
        } else if (event.url == '/forgot-password') {
            return (this.isShowSidebar = false);
        } else if (event.url == '/reset-password') {
            return (this.isShowSidebar = false);
        } else if (event.url == '/login') {
          return (this.isShowSidebar = false);
        } else if (event.url == '/sign-up') {
          return (this.isShowSidebar = false);
        } else if (event.url == '/user-registration') {
          if (this.isEditProfile) {
            return (this.isShowSidebar = true);
          } else {
            return (this.isShowSidebar = false);
          }
        } else if (event.url == '/email-verification') {
          return (this.isShowSidebar = false);
        } else return (this.isShowSidebar = true);
      });
    this.user = JSON.parse(localStorage.getItem('merchant_currentUser1'));
    this.router.events.subscribe((event) => {
      this.user = JSON.parse(localStorage.getItem('merchant_currentUser1'));
      if ((this.user, event instanceof NavigationEnd)) {
        this.url = event.url;
        if (
          this.url == '/dashboard' &&
          this.user &&
          this.user?.isEmailVarified == true &&
          this.user?.isFirstUpdateDone == true
        ) {
          this.router.navigateByUrl('/dashboard');
        } else if (
          (this.url == '/' ||
            this.url == '/login' ||
            this.url == '/sign-in' ||
            this.url == '/sign-up') &&
          this.user &&
          this.user.id &&
          this.user.isEmailVarified == true &&
          this.user.isFirstUpdateDone == true
        ) {
          this.router.navigateByUrl('/dashboard');
        }
      }
    });
  }


  ngOnInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // This block will be executed whenever the URL changes
        const currentUrl = this.router.url;
        if((currentUrl !== '/perpetual-add') && (currentUrl !== '/add-and-buy')){
          localStorage.removeItem('discountImg')
        }
      }
    });
  }

  getMerchantById(id) {
    this.authenticationService.getMerchantById(id).subscribe(
      (data) => { },
      (error) => {
        if (error.error.message == 'Unauthorized') {
          this.authenticationService.logout();
        }
      }
    );
  }


  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
